<template>
    <div>
        <div class="container-fluid bg-darker dark">

            <div class="col-sm-12 py-3">
                <i class="ico-search fs-giant"></i>
                <input type="text" class="searchTitle dark fs-giant" placeholder="Search by activity title" v-model="filters.title"></input>
            </div>

            <!-- <div class="col-sm-12 pt-3 pb-3">
                <div class="row">
                    <div class="col-sm-2">
                        <v-select :options="locationsToList" label="name" v-model="selectedLocation" :on-change="changedLocation(selectedLocation)"></v-select>
                    </div>
                    <div class="col-sm-2">
                        <v-select :options="resourcesToList" label="name" v-model="selectedResource" :on-change="changedResource(selectedResource)"></v-select>
                    </div>
                </div>
            </div> -->

        </div>

        <div class="col-sm-12 py-2 d-flex justify-content-center bg-lighter flex-wrap" v-if="categories.length > 0">
            <button class="categoryBtn btn tertiary fs-large border-medium mx-2 dark my-2" :class="{'selected': selectedCategoryId == null}" @click="seeAllCategories">See all</button>
            <button class="categoryBtn btn tertiary fs-large border-medium mx-2 dark my-2 position-relative" :class="{'selected': category.id == selectedCategoryId}" v-for="category in categoriesWithQuantity" v-if="category.productQauntity > 0" @click="selectCategory(category)">
                <span class="productQauntityIndicator fs-smaller radius-stadium px-2">{{category.productQauntity}}</span>
                <span>{{category.name}}</span>
            </button>
        </div>

    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    export default {
        data: function() {
            return {
                dummyLoactions: [
                    'Albufeira',
                    'Olhão',
                    'Portimão',
                    'Sagres'
                ],
                selectedDummyLocation: 'Albufeira',
                dummyResources: [
                    'Barco 1',
                    'Barco 2',
                    'Barco 3',
                    'Barco 4',
                    'Barco 5'
                ],
                selectedDummyResource: 'Barco 1',
                selectedCategoryId: null,
                selectedResource: null,
                selectedLocation: null,
            }
        },
        created: function () {
            // this.countProductsPerCategory()
        },
        props:{
            locations:{
                type: Array,
                default: []
            },
            resources:{
                type: Array,
                default: []
            },
            categories:{
                type: Array,
                default: []
            },
            filters:{
                type: Object,
                default: {}
            },
            allProducts:{
                type: Array,
            }
        },
        computed: {
            locationsToList: function() {
                if(this.locations){
                    //this JSON gymanstic so that the a bind is not created, otherwise the changes here will affect this.resources
                    let locationsEdited = JSON.parse(JSON.stringify(this.locations));

                    locationsEdited.unshift({
                        id: null,
                        name: 'All locations'
                    });

                    //set default dropdown
                    if(this.selectedLocation == null){
                        this.selectedLocation = locationsEdited[0]
                    }

                    return locationsEdited;
                } else {
                    return [];
                }
            },
            resourcesToList: function() {
                if(this.resources){
                    //this JSON gymanstic so that the a bind is not created, otherwise the changes here will affect this.resources
                    let resourcesEdited = JSON.parse(JSON.stringify(this.resources));

                    resourcesEdited.unshift({
                        id: null,
                        name: 'All resources'
                    });

                    //set default dropdown
                    if(this.selectedResource == null){
                        this.selectedResource = resourcesEdited[0]
                    }

                    return resourcesEdited;
                } else {
                    return [];
                }
            },
            categoriesWithQuantity: function (){
                let categoriesToProcess = this.categories

                for (let product of this.allProducts) {

                        for (let category of categoriesToProcess) {

                            for (let categoryInProduct of product.categoryList) {

                                if(categoryInProduct.id == category.id){

                                    if(!category.productQauntity){
                                        this.$set(category, 'productQauntity', 0)
                                    }

                                    category.productQauntity++

                                }

                            }

                        }

                }

                return categoriesToProcess
            }
        },
        methods: {
            changedLocation: function(selectedLocation) {
                this.filters.location = selectedLocation
            },
            changedResource: function(selectedResource) {
                this.filters.resourceId = selectedResource.id
            },
            selectCategory: function(category) {
                this.selectedCategoryId = category.id;
                this.filters.categoryId = category.id;
            },
            seeAllCategories: function() {
                this.selectedCategoryId = null;
                this.filters.categoryId = null;
            },
            countProductsPerCategory: function () {
                for (let product of this.allProducts) {

                        for (let category of this.categories) {
                            if(product.category.id == category.id){

                                if(!category.productQauntity){
                                    this.$set(category, 'productQauntity', 0)
                                }

                                category.productQauntity++

                            }
                        }

                }
            }
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables.scss';
@import '../../../../assets/scss/_utility.scss';

    .searchTitle{
        background: none !important;
        border: none !important;
    }

    //make dropdowns bigger
    .dropdown-toggle{
        height: auto !important;
        padding: 3px 0 !important;

        .open-indicator{
            margin-bottom: 3px !important;
        }
    }

    .categoryBtn{
        height: auto;
        padding: 0.8rem 4rem;

        &.selected, &.selected:hover{
            background: $dark;
            color: $lightest !important;
        }

        .productQauntityIndicator{
            position: absolute;
            right: 5px;
            top: 5px;
            background-color: $color-6;
            color: $lightest;
            line-height: 1rem;
        }

    }

</style>



// WEBPACK FOOTER //
// FilterArea.vue?52247218